import axiosConfig from "./axiosConfig";
import { HealthEvent } from "./getSiteHealthEvents";

export interface UpdateHealthEventRequest {
  impactType?: string;
  notes?: string | null;
  category?: string;
  severity?: string;
  detectedAt?: string;
  resolvedAt?: string | null;
}

const updateHealthEvent = async (
  authToken: string,
  siteId: string,
  eventId: number,
  update: UpdateHealthEventRequest
): Promise<HealthEvent> => {
  const { data } = await axiosConfig.patch(
    `/site/${siteId}/health/events/${eventId}`,
    update,
    { headers: { Authorization: `Bearer ${authToken}` } }
  );
  return data;
};

export default updateHealthEvent;
